import {
  Box,
  Paper,
  Stack,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import _ from 'lodash';
import {
  PrimaryButton,
  TableButton,
} from '../../../components/style/ButtonStyle';
import {
  MaxWidthCell,
  PrettyScrollbarTableWrap,
  PrimaryBorderTable,
} from '../../../components/style/TableStyle';
import { FormTitle } from '../../../components/style/TextStyle';
import { AddButtonIcon } from '../../../layouts/dashboard/nav/IconButton';

import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import Empty from '../../../components/common/Empty';
import { useAuthAxios } from '../../../hooks/useAuthAxios';
import useResponsive from '../../../hooks/useResponsive';
import { useYupValidationResolver } from '../../../hooks/useYupValidationResolver';
import { fDate } from '../../../utils/formatTime';
import AddCategoryButton from './Common/AddCategoryButton';
import { CreateStatusForm } from './Common/CreateCategoryForm';
import DeleteCategoryButton from './Common/DeleteButton';
import EditCategoryButton from './Common/EditCategoryButton';
import { EditStatusForm } from './Common/EditCategoryForm';
import { statusHeader } from './header';
import {
  statusDefaultValue,
  statusSchema,
} from './Common/DefaultValuesAndSchema';

export default function StatusCategory() {
  const mdUp = useResponsive('up', 'md');
  const navigate = useNavigate();
  const [getStatusesResult, getStatuses] = useAuthAxios(
    {
      method: 'GET',
      url: '/api/v1/inspectionResultType',
    },
    { manual: false },
  );
  const statuses = _.get(getStatusesResult, 'response.data');
  const isEmpty = _.isEmpty(statuses);

  useEffect(() => {
    getStatuses();
  }, [getStatuses]);

  const resolver = useYupValidationResolver(
    Yup.object().shape({
      ...statusSchema,
    }),
  );

  const form = useForm<any>({
    mode: 'onTouched',
    resolver,
    defaultValues: {
      ...statusDefaultValue,
    },
    shouldUnregister: false,
  });

  const [postStatusResult, postStatus] = useAuthAxios({
    method: 'POST',
    url: '/api/v1/inspectionResultType',
  });

  const onSubmitCreateForm = form.handleSubmit(function (values) {
    const payload = {
      title: values.title,
      notes: values.notes,
    };
    postStatus({ data: payload });
  });

  return (
    <Stack>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        {mdUp ? <FormTitle>상태 목록</FormTitle> : <Box />}
        {mdUp ? (
          <AddCategoryButton
            label="점검상태 추가"
            form={form}
            onSubmit={onSubmitCreateForm}
            children={<CreateStatusForm form={form} />}
            postResult={postStatusResult}
            getResult={getStatuses}
          />
        ) : (
          <Stack>
            <PrimaryButton
              onClick={() => navigate(`/category/status/form`)}
              startIcon={<AddButtonIcon />}
            >
              상태 추가
            </PrimaryButton>
            <Box />
          </Stack>
        )}
      </Stack>
      {isEmpty ? (
        <Empty />
      ) : (
        <PrettyScrollbarTableWrap>
          <TableContainer
            component={Paper}
            sx={{ mt: '16px !important', maxHeight: '506px' }}
          >
            <PrimaryBorderTable sx={{ minWidth: 910 }} size="small">
              <TableHead>
                <TableRow>
                  {_.map(statusHeader, t => (
                    <TableCell align="center" key={t.id}>
                      {t?.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {_.map(statuses, status => {
                  const isDefault = _.get(status, 'title') === '기타';
                  return (
                    <TableRow key={status.inspectionResultTypeId}>
                      <TableCell align="center">
                        {status?.title || '-'}
                      </TableCell>
                      <TableCell align="center">
                        {fDate(status?.createdAt, 'yyyy-MM-dd') || '-'}
                      </TableCell>
                      <TableCell align="center">
                        {status?.createdBy || '-'}
                      </TableCell>
                      <TableCell align="center">
                        {status?.creatorDept || '-'}
                      </TableCell>
                      <MaxWidthCell align="center">
                        {status?.notes || '-'}
                      </MaxWidthCell>
                      <TableCell align="center">
                        {mdUp ? (
                          <EditCategoryButton
                            label="상태 수정"
                            form={form}
                            children={
                              <EditStatusForm
                                form={form}
                                statusId={status?.inspectionResultTypeId}
                              />
                            }
                            category="inspectionResultType"
                            categoryId={status?.inspectionResultTypeId}
                            getResult={getStatuses}
                          />
                        ) : (
                          <TableButton
                            onClick={() => {
                              navigate(
                                `/category/status/${status?.inspectionResultTypeId}/form`,
                              );
                            }}
                          >
                            수정
                          </TableButton>
                        )}
                      </TableCell>
                      <TableCell align="center">
                        {isDefault ? (
                          <></>
                        ) : (
                          <DeleteCategoryButton
                            category="inspectionResultType"
                            categoryId={status?.inspectionResultTypeId}
                            getResult={getStatuses}
                          />
                        )}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </PrimaryBorderTable>
          </TableContainer>
        </PrettyScrollbarTableWrap>
      )}
    </Stack>
  );
}
